package org.teddapp.project.ui

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/**
 * Anneau de progression : piste en retrait, tracé plein dans la teinte de marque (ou la
 * couleur passée), valeur en chiffres tabulaires au centre.
 */
@Composable
fun TeddRing(
    value: Int,
    modifier: Modifier = Modifier,
    size: Dp = 64.dp,
    strokeWidth: Dp = 6.dp,
    accent: Color? = null,
    showLabel: Boolean = true,
    sub: String? = null,
) {
    val v = value.coerceIn(0, 100)
    val brush = SolidColor(accent ?: TeddTokens.LimeStrong)

    val trackColor = TeddTokens.SurfaceSunken
    Box(
        modifier = modifier.size(size),
        contentAlignment = Alignment.Center,
    ) {
        Canvas(modifier = Modifier.size(size)) {
            val canvas = this.size.minDimension
            val stroke = strokeWidth.toPx()
            val radius = (canvas - stroke) / 2f
            val topLeft = Offset(stroke / 2f, stroke / 2f)
            val arcSize = Size(radius * 2f, radius * 2f)

            // track
            drawArc(
                color = trackColor,
                startAngle = -90f,
                sweepAngle = 360f,
                useCenter = false,
                topLeft = topLeft,
                size = arcSize,
                style = Stroke(width = stroke, cap = StrokeCap.Round),
            )
            // progress
            if (v > 0) {
                drawArc(
                    brush = brush,
                    startAngle = -90f,
                    sweepAngle = 360f * v / 100f,
                    useCenter = false,
                    topLeft = topLeft,
                    size = arcSize,
                    style = Stroke(width = stroke, cap = StrokeCap.Round),
                )
            }
        }
        if (showLabel) {
            // Label centré (mono)
            val px = size.value
            androidx.compose.foundation.layout.Column(
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Text(
                    text = "$v",
                    color = TeddTokens.Ink,
                    fontFamily = LocalTeddFonts.current.mono,
                    fontSize = (px * 0.28f).sp,
                    fontWeight = FontWeight.Medium,
                    letterSpacing = (-0.5).sp,
                )
                if (sub != null) {
                    Text(
                        text = sub,
                        color = TeddTokens.InkMuted,
                        fontSize = (px * 0.13f).sp,
                    )
                }
            }
        }
    }
}
